<template>
    <div class="w-[100vw] h-[100vh] fixed top-0 left-0 flex justify-center items-center bg-[#0000005a]">
        <div class=" text-white gap-4 p-4 bg-[#5D5D98] rounded-[10px]  flex flex-col ">
            <div class="w-full gap-[2rem] flex justify-between items-center">
                <h3 class="text-[#ff9b05]">Confirmar Data e Hora</h3>
                <div class="flex gap-2 items-center">
                    <AppButton class=" text-white" v-bind:visibility="true" 
                        left_icon="fa-regular fa-circle-xmark fa-xl"
                        emitType="close" 
                        @close="close" 
                        :width="23" :height="23" />
                </div>
            </div>

            <div class="flex flex-col gap-2 ">
                <!-- INÍCIO: Now separate date/time inputs -->
                <div class=" flex gap-2">
                    <label for="cliente" class="min-w-[7.5rem]">Inicio:</label>
                    <input 
                        type="date" 
                        v-model="inicioDate" 
                        class="w-[9rem] text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]"
                        :class="{ 'red-border': !isValidDateTime(model.inicio) }"
                    />
                    <input 
                        type="time" 
                        v-model="inicioTime" 
                        class="w-[8.5rem] text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]"
                        :class="{ 'red-border': !isValidDateTime(model.inicio) }"
                    />
                </div>
                
                <!-- FIM: Now separate date/time inputs -->
                <div class=" flex gap-2">
                    <label for="Fim" class="min-w-[7.5rem]">Fim:</label>
                    <input 
                        type="date" 
                        v-model="fimDate" 
                        class="w-[9rem] text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]"
                        :class="{ 'red-border': !isValidDateTime(model.fim) }"
                    />
                    <input 
                        type="time" 
                        v-model="fimTime" 
                        class="w-[8.5rem] text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px]"
                        :class="{ 'red-border': !isValidDateTime(model.fim) }"
                    />
                </div>

                <AppButton 
                    v-bind:visibility="true" 
                    :font_size="12" 
                    color="#ff9b05"
                    left_icon="fa-solid fa-pen-to-square" 
                    text="Confirmar" 
                    emitType="select" 
                    @select="save_config" 
                />
            </div>
        </div>
    </div>

    
</template>

<script>

import AppButton from '@/components/updated/button.vue'
import { toast } from 'vue3-toastify';
export default {
    name: 'ordemServicoDateTime',
    components: {
        AppButton
    },

    props: {
        model_data: {
            type: Object,
            default: () => ({
                inicio: "",
                fim: "",
            })
        },
    },

    data() {
        return {
            model: this.model_data,
        }
    },

    methods: {
        save_config() {
            if (!this.validateForm()) {
                return;
            }
            
            this.$emit("save-data", this.model);
        },
        close() {
            this.$emit("close");
        },
        isEmptyField(field) {
            if (["inicio", "fim"].includes(field)) {
                return (this.model[field] === '' || this.model[field] <= 0);
            }
            return false;
        },
        validateForm() {
            if (
                !this.model.inicio ||
                !this.model.fim 
            ) {
                toast("Preencha todos os campos!", {
                    theme: "auto",
                    type: "warning",
                    position: "top-center",
                    autoClose: 1000,
                });
                return false;
            }
            //chekck if of the fields is empty
            if (this.isEmptyField("inicio") || this.isEmptyField("fim")) {
                toast("Preencha todos os campos!", {
                    theme: "auto",
                    type: "warning",
                    position: "top-center",
                    autoClose: 1000,
                });
                return false;
            }
            //also check if initial date or time is greater than final date
            if (this.model.inicio > this.model.fim) {
                toast("Data e hora de início não podem ser maiores que a data e hora de fim!", {
                    theme: "auto",
                    type: "warning",
                    position: "top-center",
                    autoClose: 1000,
                });
                return false;
            }
            
            return true;
        },
        
        remove(field) {
            this.model[field] = { nome: "", id: 0 };
        },
        isValidDateTime(value) {
            // Checks for the basic pattern: YYYY-MM-DDTHH:MM
            const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
            return pattern.test(value);
        },
        
    },

    computed: {
        // -------------------- INICIO --------------------
        inicioDate: {
            get() {
                // If model.inicio is empty, return an empty string (so no date is displayed)
                if (!this.model.inicio) return "";
                return this.model.inicio.split("T")[0]; // YYYY-MM-DD
            },
            set(newDate) {
                // Keep the existing time part if any; default to "00:00"
                let timePart = "00:00";
                if (this.model.inicio && this.model.inicio.includes("T")) {
                    timePart = this.model.inicio.split("T")[1];
                }
                this.model.inicio = `${newDate}T${timePart}`;
            }
        },
        inicioTime: {

            get() {
                //somethimes the format is like this:"2025-03-24T00:10:00Z" and 
                //so we need to split the string and need to remove the seconds part
                //somethimes the format is like this:"2025-03-24 00:10" and the T is missing
                //so we need to split the string and need to remove the seconds part
                if (!this.model.inicio) return "";
                if(this.model.inicio.includes("T")){
                    return this.model.inicio.split("T")[1].split(":").slice(0, 2).join(":");
                }else{
                    return this.model.inicio.split(" ")[1].split(":").slice(0, 2).join(":");
                }

            },
            set(newTime) {
                // Keep the existing date part; default to today's date if empty
                let datePart = "";
                if (this.model.inicio && this.model.inicio.includes("T")) {
                    datePart = this.model.inicio.split("T")[0];
                } else {
                    // If there's no date set yet, you could default to e.g. '2025-01-01'
                    // or just keep it empty if you prefer:
                    datePart = "2025-01-01";
                }
                this.model.inicio = `${datePart}T${newTime}`;
            }
        },
        // -------------------- FIM --------------------
        fimDate: {
            get() {
                if (!this.model.fim) return "";
                return this.model.fim.split("T")[0];
            },
            set(newDate) {
                let timePart = "00:00";
                if (this.model.fim && this.model.fim.includes("T")) {
                    timePart = this.model.fim.split("T")[1];
                }
                this.model.fim = `${newDate}T${timePart}`;
            }
        },
        fimTime: {
            get() {
                if (!this.model.fim) return "";
                if(this.model.fim.includes("T")){
                    return this.model.fim.split("T")[1].split(":").slice(0, 2).join(":");
                }else{
                    return this.model.fim.split(" ")[1].split(":").slice(0, 2).join(":");
                }
            },
            set(newTime) {
                let datePart = "";
                if (this.model.fim && this.model.fim.includes("T")) {
                    datePart = this.model.fim.split("T")[0];
                } else {
                    datePart = "2025-01-01";
                }
                this.model.fim = `${datePart}T${newTime}`;
            }
        },
    },

    watch: {
        model_data: {
            handler(val) {
                this.model = val;
            },
            deep: true,
            immediate: true
        }
    }

}

</script>